// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2ARfR","loaderOuter":"PageOverlayLoader_loaderOuter__ti0rP"};